'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError from "./com.raquo.airstream.core.-Airstream-Error.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024 from "./com.raquo.airstream.core.-Airstream-Error$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
class $c_Lcom_raquo_airstream_core_AirstreamError$VarError extends $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError.$c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(message, cause) {
    super();
    this.rz = null;
    this.ry = null;
    this.rz = message;
    this.ry = cause;
    $j_java$002elang$002e$002dObject.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().SN(message, cause), null, true, true);
    if ((!cause.k())) {
      this.BO(cause.C());
    }
  }
  I() {
    return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
  }
  m() {
    return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
  }
  f(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$VarError)) {
      if ((this.rz === x$0.rz)) {
        var x = this.ry;
        var x$2 = x$0.ry;
        return ((x === null) ? (x$2 === null) : x.f(x$2));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  n() {
    return 2;
  }
  o() {
    return "VarError";
  }
  g(n) {
    if ((n === 0)) {
      return this.rz;
    }
    if ((n === 1)) {
      return this.ry;
    }
    throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  b() {
    return ((("VarError: " + this.rz) + "; cause: ") + this.ry);
  }
}
export { $c_Lcom_raquo_airstream_core_AirstreamError$VarError as $c_Lcom_raquo_airstream_core_AirstreamError$VarError };
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$VarError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cQ)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$VarError as $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$VarError };
var $d_Lcom_raquo_airstream_core_AirstreamError$VarError = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_AirstreamError$VarError, "com.raquo.airstream.core.AirstreamError$VarError", ({
  cQ: 1,
  bl: 1,
  H: 1,
  a: 1,
  b: 1,
  c: 1
}));
export { $d_Lcom_raquo_airstream_core_AirstreamError$VarError as $d_Lcom_raquo_airstream_core_AirstreamError$VarError };
